import React from 'react';
import { translationProvider } from 'twain-sport-fe-mono/store/translations';
import { ILeftVsRightKeys, IParticipant } from 'twain-sport-fe-mono/interfaces';
import classes from './ParticipantInfo.module.scss';

interface IProps {
    participant?: IParticipant;
    rngCourt?: ILeftVsRightKeys;
}

export const ParticipantInfo: React.FC<IProps> = (props) => {
    const render = React.useCallback(() => {
        if (props.rngCourt) {
            return (
                <div className={classes.nickname}>
                    {translationProvider.string(`rng_player_${props.rngCourt}`)}
                </div>
            );
        }
        return props.participant ? (
            <>
                <div className={classes.position}>#{props.participant.jerseyNumber}</div>
                <div className={classes.nickname}>{props.participant.nickname}</div>
                <div className={classes.rank}>
                    ({translationProvider.string('rank')} {props.participant.rank})
                </div>
            </>
        ) : (
            translationProvider.string('tbd')
        );
    }, []);
    return <div className={classes.container}>{render()}</div>;
};
